export const GET_DRIVER_CITATION_STATES = "pay-citation/GET_DRIVER_CITATION_STATES";
export const SET_DRIVER_CITATION_STATES = "pay-citation/SET_DRIVER_CITATION_STATES";
export const GET_DRIVER_CREDIT_CARD_VALUE = "pay-citation/GET_DRIVER_CREDIT_CARD_VALUE";
export const SET_DRIVER_CREDIT_CARD_VALUE = "pay-citation/SET_DRIVER_CREDIT_CARD_VALUE";
export const HIDE_IMAGE_VIEWER = "HIDE_IMAGE_VIEWER";
export const SHOW_IMAGE_VIEWER = "SHOW_IMAGE_VIEWER";

export const SHOW_WITHOUT_LOGIN_PRELOADER = "pay-citation/SHOW_WITHOUT_LOGIN_PRELOADER";
export const HIDE_WITHOUT_LOGIN_PRELOADER = "pay-citation/HIDE_WITHOUT_LOGIN_PRELOADER";

export const START_EXTERNAL_CITATION_PAYMENT = 'pay-citation/START_EXTERNAL_CITATION_PAYMENT';

export const getDriverCitationStates = (data) => {
  return {
    type: GET_DRIVER_CITATION_STATES,
    payload: data,
  };
};

export const setDriverCitationStates = (data) => {
  return {
    type: SET_DRIVER_CITATION_STATES,
    payload: data,
  };
};

export const hideImageViewerAction = (data) => {
  return {
    type: HIDE_IMAGE_VIEWER,
    payload: data,
  };
};

export const showImageViewerAction = (data) => {
  return {
    type: SHOW_IMAGE_VIEWER,
    payload: data,
  };
};

export const getDriverCreditCardValue = (data) => {
  return {
    type: GET_DRIVER_CREDIT_CARD_VALUE,
    payload: data,
  };
};

export const setDriverCreditCardValue = (data) => {
  return {
    type: SET_DRIVER_CREDIT_CARD_VALUE,
    payload: data,
  };
};

export const showWithoutLoginPreLoaderModal = () => {
  return {
    type: SHOW_WITHOUT_LOGIN_PRELOADER
  };
};

export const hideWithoutLoginPreLoaderModal = () => {
  return {
    type: HIDE_WITHOUT_LOGIN_PRELOADER
  };
};

export const startExternalCitationPayment = (citationId) => ({
  type: START_EXTERNAL_CITATION_PAYMENT,
  payload: { citationId },
});

